import { render, staticRenderFns } from "./MySalesPage.vue?vue&type=template&id=6f2e2ff0&scoped=true"
import script from "./MySalesPage.vue?vue&type=script&lang=js"
export * from "./MySalesPage.vue?vue&type=script&lang=js"
import style0 from "./MySalesPage.vue?vue&type=style&index=0&id=6f2e2ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e2ff0",
  null
  
)

export default component.exports